import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTab } from 'vuetify/lib/components/VTabs';
import { VTabs } from 'vuetify/lib/components/VTabs';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTabs,{attrs:{"align-with-title":""},model:{value:(_vm.tabs),callback:function ($$v) {_vm.tabs=$$v},expression:"tabs"}},_vm._l((_vm.menuLinks),function(link,i){return _c(VTab,{key:i,attrs:{"to":link.to}},[_c(VIcon,{staticClass:"mx-2"},[_vm._v(_vm._s(link.icon))]),_c('span',{staticClass:"text-capitalize text-body-1 font-weight-medium"},[_vm._v(_vm._s(link.name))])],1)}),1)}
var staticRenderFns = []

export { render, staticRenderFns }